// extracted by mini-css-extract-plugin
export default {"td":"DistribuidoresIndex_td__6+jKD","inscricao":"DistribuidoresIndex_inscricao__4R8qi"};